import { UserService } from './user.service';
import { ModelData } from './../base-models/model-data';
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

@Injectable({
    providedIn: 'root'
})

export class ModelDataService {
    constructor(
        private router: Router,
        private userService: UserService
    )
    {}

    GetModelDataByPath(path: string){
        return new ModelData(this.userService).LoadModelData(this.getRouteData('', this.router.config, path, null));
    }

    private getRouteData(parent: string, config: any, path: string, routeData: any){
        //let routeData = {};
        for(let i = 0; i < config.length; i++){
            let r = config[i];
            if(r.path == path){
                //return r.data;
                routeData = r.data;
                break;
            }
            
            else if(r._loadedConfig && r._loadedConfig.routes && r.path){
                //let tempRoute = 
                routeData = this.getRouteData(parent + '/' + r.path, r._loadedConfig.routes, path, routeData);
                //if(tempRoute.path == path)
                    //return tempRoute.data;
            }
            else if(r.children){
                //let tempRoute = 
                routeData = this.getRouteData(parent + '/' + r.path, r.children, path, routeData);
                //if(tempRoute.path == path)
                    //return tempRoute.data;
            }
        }
        return routeData;
    }
}